import { doInteraction } from './Analytics';
export function SelectMapLink() {
    doInteraction(`DASH SHPE|MAP, MAPLINK`);
}